var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"adminHeader"},[_c('LogoSvg',{staticClass:"adminHeader__logo"}),(_vm.menu)?_c('Menu'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }